import { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select, { components } from "react-select";
import { putMedicalTest } from "../../connections/putMedicalTest";
import { useQuery } from "@tanstack/react-query";
import { getLabsList } from "../../connections/getLabsList";
import { getMedicalTestCat } from "../../connections/getMedicalTestCat";
import { getMedicalTest } from "../../connections/getMedicalTest";
import useDebounce from "../../utils/hooks";
import { Search } from "@mui/icons-material";
const defaultLabel = "LAB";

const UpdateMedicalTest = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const [formState, setFormState] = useState({});
  const [selectedTestOptions, setSelectedTestOption] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const medicalTestData = location.state || null;
  const handleChange = (name, value) => {
    if (name === "composite_fields") {
      setSelectedTestOption(() => [...value]);
    } else {
      setFormState((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  // lab options \\\]
  const { data: getAllLabs, isFetching: isLoading } = useQuery({
    queryKey: ["getLabsList", "all"],
    queryFn: () => getLabsList(user?.token, "all", null, null),
    enabled: !!user?.token,

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const AllLabOptions = getAllLabs?.payload?.labs || [];
  const formattedLabOptions = AllLabOptions?.map((el) => ({
    value: el?.id,
    label: el?.name,
  }));

  //medical test cat option
  const { data: getAllMedicalTestCat, isFetching: categoryLoader } = useQuery({
    queryKey: ["getMedicalTestCat", "all"],
    queryFn: () => getMedicalTestCat(user?.token, "all", null, null),
    enabled: !!user?.token,

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const AllMedicalTestCatOptions =
    getAllMedicalTestCat?.payload?.medical_test_categories || [];
  const formattedMedicalTestCatOptions = AllMedicalTestCatOptions?.map(
    (el) => ({
      value: el?.id,
      label: el?.name,
    })
  );
  // Find the LAB option if it exists
  const defaultMedicalTestCatOption =
    formattedMedicalTestCatOptions.find(
      (option) => option.label === defaultLabel
    ) || null;

  //medical test option for composite filed [this doubt]
  const [medicalInput, setMedicalInput] = useState("");
  const handleMedicalChange = (inputValue) => {
    // e.preventDefault();
    setMedicalInput(inputValue);
  };
  const debouncedInputMedicine = useDebounce(medicalInput, 1000);

  const { data: medicalTestDataList, isFetching: compositeLoader } = useQuery({
    queryKey: ["getMedicalTest", debouncedInputMedicine],
    queryFn: () =>
      getMedicalTest(user?.token, "null", 1, 10, debouncedInputMedicine),
    enabled: !!debouncedInputMedicine,

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const AllMedicalTestOptions =
    medicalTestDataList?.payload?.medical_tests || [];
  const formattedMedicalTestOptions = AllMedicalTestOptions?.map((el) => ({
    value: el?.id,
    label: el?.name,
  }));

  const handleAddMedicalTest = async (e) => {
    if (!formState.code) {
      toast.error("Code is required");
      return;
    }
    if (+formState?.discount > +formState?.amount) {
      toast.error("Discount cannot be greater than the amount.");
      return;
    }

    e.preventDefault();
    const payload = {
      medical_test: {
        ...formState,
        composite_fields: selectedTestOptions?.map((el) => el.value),
      },
    };

    try {
      const data = await putMedicalTest(
        user?.token,
        payload,
        medicalTestData?.id
      );
      if (data.status.status === "SUCCESS") {
        toast.success("Medical Test Updated Successfully");
        setFormState({});
        navigate(-1);
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error.message);
    }
  };
  useEffect(() => {
    if (medicalTestData) {
      console.log(medicalTestData);
      setFormState((prev) => ({
        ...prev,
        name: medicalTestData?.name,
        code: medicalTestData?.code,
        lab_id: medicalTestData?.lab?.id,
        medical_test_category_id:
          medicalTestData?.medical_test_category?.id ||
          defaultMedicalTestCatOption?.value,
        female_min: medicalTestData?.female_min,
        male_min: medicalTestData?.male_min,
        female_max: medicalTestData?.female_max,
        male_max: medicalTestData?.male_max,
        unit: medicalTestData?.unit,
        critical: medicalTestData?.critical,
        sorting_order: medicalTestData?.sorting_order,
        amount: medicalTestData?.amount,
        discount: medicalTestData?.discount,
        cost_to_lab: medicalTestData?.cost_to_lab,
        number_of_films: medicalTestData?.number_of_films,
        composite: medicalTestData?.composite,
        // composite_fields:
      }));
      setSelectedTestOption(
        medicalTestData?.composite_tests?.map((el) => ({
          value: el?.value || el?.toString(),
          label: el?.label || el?.toString(),
        }))
      );
    }
  }, [medicalTestData]);
  // console.log(formState, "formstate", selectedTestOptions);
  return (
    <>
      <Header />
      <Sidebar activeClassName="medical-test-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={-1}>Medical Test </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      Update Medical Test
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      {medicalTestData?.id}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Update Medical Test</h4>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Name
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.name}
                              name="name"
                              onChange={(e) =>
                                handleChange("name", e.target.value)
                              }
                              className="form-control"
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Code
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              disabled
                              value={formState?.code}
                              name="code"
                              onChange={(e) =>
                                handleChange("code", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Lab
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <Select
                              isLoading={isLoading}
                              options={formattedLabOptions}
                              value={
                                formattedLabOptions.find(
                                  (option) => option.value === formState?.lab_id
                                ) || null
                              }
                              onChange={(selectedOptions) => {
                                handleChange("lab_id", selectedOptions?.value);
                              }}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "#007A99"
                                    : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #007A99"
                                    : "none",
                                  "&:hover": {
                                    borderColor: "rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                              isSearchable
                              placeholder="Choose lab"
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Medical test category
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <Select
                              isLoading={categoryLoader}
                              options={formattedMedicalTestCatOptions}
                              value={
                                formattedMedicalTestCatOptions.find(
                                  (option) =>
                                    option.value ===
                                    formState?.medical_test_category_id
                                ) ||
                                defaultMedicalTestCatOption ||
                                null
                              }
                              onChange={(selectedOptions) => {
                                handleChange(
                                  "medical_test_category_id",
                                  selectedOptions?.value
                                );
                              }}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "#007A99"
                                    : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #007A99"
                                    : "none",
                                  "&:hover": {
                                    borderColor: "rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                              isSearchable
                              placeholder="Choose option"
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Female Min
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.female_min}
                              name="female_min"
                              onChange={(e) =>
                                handleChange("female_min", e.target.value)
                              }
                              className="form-control"
                              type="number"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Male Min
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.male_min}
                              name="male_min"
                              onChange={(e) =>
                                handleChange("male_min", e.target.value)
                              }
                              className="form-control"
                              type="number"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Female Max
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.female_max}
                              name="female_max"
                              onChange={(e) =>
                                handleChange("female_max", e.target.value)
                              }
                              className="form-control"
                              type="number"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Male Max
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.male_max}
                              name="male_max"
                              onChange={(e) =>
                                handleChange("male_max", e.target.value)
                              }
                              className="form-control"
                              type="number"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Unit
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.unit}
                              name="unit"
                              onChange={(e) =>
                                handleChange("unit", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              // required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Critical
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.critical}
                              name="critical"
                              onChange={(e) =>
                                handleChange("critical", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              // required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Sorting order
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.sorting_order}
                              name="sorting_order"
                              onChange={(e) =>
                                handleChange("sorting_order", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              // required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Amount
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.amount}
                              name="amount"
                              onChange={(e) =>
                                handleChange("amount", e.target.value)
                              }
                              className="form-control"
                              type="number"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Discount
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.discount}
                              name="discount"
                              onChange={(e) =>
                                handleChange("discount", e.target.value)
                              }
                              className="form-control"
                              type="number"
                              // required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Cost to lab
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.cost_to_lab}
                              name="cost_to_lab"
                              onChange={(e) =>
                                handleChange("cost_to_lab", e.target.value)
                              }
                              className="form-control"
                              type="number"
                              // required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Number of films
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.number_of_films}
                              name="number_of_films"
                              onChange={(e) =>
                                handleChange("number_of_films", e.target.value)
                              }
                              className="form-control"
                              type="number"
                              // required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Composite Fields
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <Select
                              components={{
                                DropdownIndicator: (props) => (
                                  <components.DropdownIndicator {...props}>
                                    <Search style={{ color: "#999" }} />
                                  </components.DropdownIndicator>
                                ),
                                IndicatorSeparator: () => null,
                              }}
                              onInputChange={handleMedicalChange}
                              isLoading={compositeLoader}
                              options={formattedMedicalTestOptions}
                              value={selectedTestOptions?.map((test) => ({
                                value: test.value,
                                label: test.label,
                              }))}
                              // value={formState?.composite_fields?.map(
                              //   (test) => ({
                              //     value: test,
                              //     label: formattedMedicalTestOptions.find(
                              //       (option) => option.value == test
                              //     )?.label, // Find the label that matches the value
                              //   })
                              // )}
                              onChange={(selectedOptions) => {
                                // Convert selectedOptions to an array of values
                                // const selectedValues = Array.isArray(
                                //   selectedOptions
                                // )
                                //   ? selectedOptions.map((option) =>
                                //       option?.value?.toString()
                                //     )
                                //   : [];

                                handleChange(
                                  "composite_fields",
                                  selectedOptions
                                ); // Update formState with values only
                              }}
                              noOptionsMessage={({ inputValue }) =>
                                inputValue
                                  ? "No results found"
                                  : "Type keyword to search"
                              }
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "#007A99"
                                    : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #007A99"
                                    : "none",
                                  "&:hover": {
                                    borderColor: "rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,

                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                              isMulti
                              isSearchable
                              placeholder="Choose Composite"
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <label>
                              Composite
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              checked={formState?.composite || false}
                              name="composite"
                              onChange={(e) =>
                                handleChange("composite", e.target.checked)
                              }
                              type="checkbox"
                              // required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 mt-4">
                          <div className="doctor-submit text-end">
                            <button
                              onClick={handleAddMedicalTest}
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(-1);
                              }}
                              type="submit"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default UpdateMedicalTest;
